/* Everwell theme JS — age gate, nav, AJAX cart drawer, PDP interactions */
(function () {
  'use strict';

  /* ---------- Age gate (21+) ---------- */
  var AGE_KEY = 'everwell_age_ok';
  var AGE_TTL = 30 * 24 * 60 * 60 * 1000; // 30 days

  function ageVerified() {
    try {
      var raw = localStorage.getItem(AGE_KEY);
      if (!raw) return false;
      var saved = JSON.parse(raw);
      return saved.t && (Date.now() - saved.t) < AGE_TTL;
    } catch (e) { return false; }
  }

  function initAgeGate() {
    var gate = document.querySelector('[data-age-gate]');
    if (!gate) return;
    // Don't gate well-known bots (content stays server-rendered regardless)
    var bot = /bot|crawl|spider|slurp|facebookexternalhit|pinterest|embedly/i.test(navigator.userAgent);
    if (bot || ageVerified()) return;

    gate.classList.add('is-active');
    document.body.classList.add('age-gate-locked');

    gate.querySelector('[data-age-yes]').addEventListener('click', function () {
      try { localStorage.setItem(AGE_KEY, JSON.stringify({ t: Date.now() })); } catch (e) {}
      gate.classList.remove('is-active');
      document.body.classList.remove('age-gate-locked');
    });
    gate.querySelector('[data-age-no]').addEventListener('click', function () {
      gate.classList.add('is-denied');
    });
  }

  /* ---------- Mobile nav ---------- */
  function initNav() {
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;
    var open = document.querySelector('[data-menu-open]');
    var close = nav.querySelector('[data-menu-close]');
    if (open) open.addEventListener('click', function () { nav.classList.add('is-open'); });
    if (close) close.addEventListener('click', function () { nav.classList.remove('is-open'); });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) nav.classList.remove('is-open');
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer, overlay;

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
  }

  function refreshCartDrawer(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) return;
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var fresh = tpl.querySelector('[data-cart-drawer]');
        if (fresh && drawer) {
          drawer.innerHTML = fresh.innerHTML;
          bindDrawerEvents();
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        var count = document.querySelector('[data-cart-count]');
        if (count) {
          count.textContent = cart.item_count;
          count.hidden = cart.item_count === 0;
        }
        if (openAfter) openCart();
      })
      .catch(function () { /* fall back to full reload on next interaction */ });
  }

  // Free-gift-with-purchase: auto-add the gift once a qualifying item is in the cart.
  // Respects a manual removal for the rest of the session; no-ops when the gift is sold out.
  function ensureGift() {
    var meta = drawer ? drawer.querySelector('[data-gift-meta]') : null;
    if (!meta || meta.dataset.giftAvailable !== 'true') return Promise.resolve();
    var giftId = parseInt(meta.dataset.giftVariant, 10);
    if (!giftId) return Promise.resolve();
    try { if (sessionStorage.getItem('ew-gift-declined')) return Promise.resolve(); } catch (e) {}
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasGift = false, qualifying = 0;
        cart.items.forEach(function (it) {
          if (it.variant_id === giftId) hasGift = true; else qualifying += it.quantity;
        });
        if (hasGift || qualifying === 0) return;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: giftId, quantity: 1 })
        }).catch(function () {});
      })
      .catch(function () {});
  }

  function bindDrawerEvents() {
    drawer.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', closeCart);
    });
    drawer.querySelectorAll('[data-remove-line]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        var meta = drawer.querySelector('[data-gift-meta]');
        if (meta && btn.dataset.variant && btn.dataset.variant === meta.dataset.giftVariant) {
          try { sessionStorage.setItem('ew-gift-declined', '1'); } catch (e) {}
        }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(btn.dataset.removeLine, 10), quantity: 0 })
        }).then(function () { refreshCartDrawer(false); });
      });
    });
    drawer.querySelectorAll('[data-upsell-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(btn.dataset.upsellAdd, 10), quantity: 1 })
        }).then(function () { return ensureGift(); })
          .then(function () { refreshCartDrawer(false); })
          .catch(function () { btn.disabled = false; });
      });
    });
  }

  function initCart() {
    drawer = document.querySelector('[data-cart-drawer]');
    overlay = document.querySelector('[data-drawer-overlay]');
    if (!drawer) return;

    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { refreshCartDrawer(true); });
    });
    overlay.addEventListener('click', closeCart);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCart();
    });
    bindDrawerEvents();

    // AJAX add-to-cart for product forms
    document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = '...'; }
        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' }
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () { return ensureGift(); })
          .then(function () { return refreshCartDrawer(true); })
          .catch(function () { form.submit(); }) // graceful fallback to cart page
          .finally(function () {
            if (btn) { btn.disabled = false; btn.textContent = label; }
          });
      });
    });
  }

  /* ---------- PDP: gallery, qty, sticky ATC, selling plans ---------- */
  function initPdp() {
    // Gallery thumbs
    var mainImg = document.querySelector('[data-pdp-main-image]');
    document.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.dataset.src;
        mainImg.srcset = '';
        document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // Quantity steppers
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          // Honour the input's own max — the drop PDP caps per-order quantity
          // there, and without this the stepper walked straight past it.
          var max = parseInt(input.getAttribute('max'), 10);
          var next = v + (btn.dataset.step === 'up' ? 1 : -1);
          if (!isNaN(max)) next = Math.min(max, next);
          input.value = Math.max(1, next);
        });
      });
    });

    // Selling plan radio → hidden input + price swap
    var form = document.querySelector('form[data-ajax-cart]');
    if (form) {
      var planInput = form.querySelector('[name="selling_plan"]');
      document.querySelectorAll('[data-purchase-option]').forEach(function (opt) {
        var radio = opt.querySelector('input[type="radio"]');
        if (!radio) return;
        radio.addEventListener('change', function () {
          if (planInput) planInput.value = radio.dataset.sellingPlan || '';
          document.querySelectorAll('[data-purchase-option]').forEach(function (o) { o.classList.remove('is-selected'); });
          opt.classList.add('is-selected');
          var priceEl = document.querySelector('[data-pdp-price]');
          if (priceEl && radio.dataset.price) priceEl.textContent = radio.dataset.price;
          var stickyPrice = document.querySelector('[data-sticky-price]');
          if (stickyPrice && radio.dataset.price) stickyPrice.textContent = radio.dataset.price;
        });
      });
    }

    // Sticky mobile ATC
    var sticky = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-atc-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '-80px 0px 0px 0px' }).observe(anchor);
      sticky.querySelector('button').addEventListener('click', function () {
        var formBtn = document.querySelector('form[data-ajax-cart] [type="submit"]');
        if (formBtn) formBtn.click();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAgeGate();
    initNav();
    initCart();
    initPdp();
  });
})();

/* Smile.io: open the rewards panel from any [data-smile-open] link. */
(function () {
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-smile-open]');
    if (!trigger) return;
    e.preventDefault();
    if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
      window.SmileUI.openPanel();
    }
  });
})();

/* The corner bone: click for cult lore fragments. Desktop-only garnish. */
(function () {
  if (window.matchMedia('(max-width: 700px)').matches) return;
  var LORE = [
    'Lore fragment 001: The skeleton applied for the bouncer job. Nobody remembers hiring him. Nobody dares fire him.',
    'Lore fragment 002: Every gummy is counted twice. The second count is ceremonial.',
    'Lore fragment 003: The daisies in the graveyard are real. The graveyard is a set. The sleep is real again.',
    'Lore fragment 004: Cerberus has three heads and exactly one favorite. Nobody agrees which.',
    'Lore fragment 005: The Cult has no meetings. Attendance is mandatory.',
    'Lore fragment 006: 2AM is not a time. It is a place, and you have been there.'
  ];
  var egg = document.createElement('button');
  egg.className = 'bone-egg';
  egg.type = 'button';
  egg.setAttribute('aria-label', 'A bone. Probably nothing.');
  egg.textContent = '🦴';
  var lore = document.createElement('div');
  lore.className = 'bone-lore';
  lore.setAttribute('role', 'status');
  document.body.appendChild(egg);
  document.body.appendChild(lore);
  var idx = 0;
  try { idx = parseInt(localStorage.getItem('ew_lore_idx') || '0', 10) % LORE.length; } catch (e) {}
  var hideTimer;
  egg.addEventListener('click', function () {
    lore.textContent = LORE[idx];
    lore.classList.add('is-open');
    idx = (idx + 1) % LORE.length;
    try { localStorage.setItem('ew_lore_idx', String(idx)); } catch (e) {}
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { lore.classList.remove('is-open'); }, 6000);
  });
  document.addEventListener('click', function (e) {
    if (!egg.contains(e.target) && !lore.contains(e.target)) lore.classList.remove('is-open');
  });
})();
